import { render } from "./Maps.vue?vue&type=template&id=978b70aa&scoped=true"
import script from "./Maps.vue?vue&type=script&lang=js"
export * from "./Maps.vue?vue&type=script&lang=js"

import "./Maps.vue?vue&type=style&index=0&id=978b70aa&lang=scss&scoped=true"

import exportComponent from "/Users/ruslan/Desktop/birch/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-978b70aa"]])

export default __exports__